import React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';

export default props => {
  return (
    <React.Fragment>
      <DialogTitle id="max-width-dialog-title">Leading Agent TPV</DialogTitle>
      <DialogContent>
        <DialogContentText>
          X, Y, Z where, <br />
          X = Total Cash-In of all leading agents for the selected
          day/week/month, <br />
          Y = Total Cash-Out of all leading agents for the selected
          day/week/month, <br />Z = X+Y i.e. Sum of total Cash-In and Cash-Out
          of all leading agents for the selected day/week/month
        </DialogContentText>
      </DialogContent>
    </React.Fragment>
  );
};
